const isProd = window.PROJECT_CONFIG.mode === 'prod'

export const ERP_TEST_HOST_TEST = 'https://c.jushuitan.com'
export const ERP_TEST_HOST_PROD = 'https://erp321.com'

export const GYL_ACCOUNT_HOST_TEST = 'https://testaccount.scm121.com'
export const GYL_ACCOUNT_HOST_PROD = 'https://account.scm121.com'

export const ERP_JUMP_PAGE = '/gotogyl.aspx'
export const GYL_ACCOUNT_HOST = isProd ? GYL_ACCOUNT_HOST_PROD : GYL_ACCOUNT_HOST_TEST
export const GYL_JUMP_PAGE = '/gylContinuePage/index'

export const CONTRACT_VERSION_OPTIONS = [
    {
        label: '企业版',
        value: '企业版'
    },
    {
        label: '专业版',
        value: '专业版'
    },
    {
        label: '高阶版',
        value: '高阶版'
    },
    {
        label: '免费版',
        value: '免费版'
    },
    {
        label: '纵横版',
        value: '纵横版'
    },
    {
        label: '纵横标准版',
        value: '纵横标准版'
    },
    {
        label: '生态版',
        value: '生态版'
    },
    {
        label: '聚货通',
        value: '聚货通'
    },
    {
        label: '胜算版',
        value: '胜算版'
    }
]

// 潜在客户分析 标签
export const WANT_FIND_GOODS = 'WANT_FIND_GOODS'
export const WANT_SUPPLY = 'WANT_SUPPLY'
export const HAVE_UNREVIEWED_COOPERATION = 'HAVE_UNREVIEWED_COOPERATION'
export const SHELVE_LOST_KA = 'SHELVE_LOST_KA'
export const DIS_TOOL_LOST_KA = 'DIS_TOOL_LOST_KA'
export const SHELVE_FAIL = 'SHELVE_FAIL'

export const POTENTIAL_CUSTOMERS_LABELS_MAP = {
    WANT_FIND_GOODS: '想找货',
    WANT_SUPPLY: '想供货',
    HAVE_UNREVIEWED_COOPERATION: '合作申请待审核',
    SHELVE_LOST_KA: '上架流失',
    DIS_TOOL_LOST_KA: '分销工具流失',
    SHELVE_FAIL: '有卡点'
}

export const POTENTIAL_CUSTOMERS_LABELS_LIST = [
    WANT_FIND_GOODS,
    WANT_SUPPLY,
    HAVE_UNREVIEWED_COOPERATION,
    SHELVE_LOST_KA,
    DIS_TOOL_LOST_KA,
    SHELVE_FAIL
].map(v => {
    return {
        value: v,
        label: POTENTIAL_CUSTOMERS_LABELS_MAP[v]
    }
})

/**
 * 定向邀约
 */
const INVITE = 'INVITE'
/**
 * 主动注册
 */
const REGISTER = 'REGISTER'
/**
 * 联合登录
 */
const ERP_LOGIN = 'ERP_LOGIN'
/**
 * ERP注册的
 */
const REGISTER_ERP = 'REGISTER_ERP'
/**
 * 主动注册前缀
 */
export const OUTER_REGISTER_PREFIX = 'OUTER_REGISTER_'
/**
 * ERP联登前缀
 */
export const ERP_LOGIN_PREFIX = 'ERP_LOGIN_'
/**
 * 关系上翻
 */
const PULL_PARTNER = 'PULL_PARTNER'

export const sourceConstList = [
    INVITE,
    REGISTER,
    ERP_LOGIN,
    REGISTER_ERP,
    OUTER_REGISTER_PREFIX,
    ERP_LOGIN_PREFIX,
    PULL_PARTNER
]
// 账号是否erp账号登录key
export const LOGIN_ACCOUNT_FROMERP = 'a_lg_from_erp'

// 是否展示旧店铺提示
export const ONLINESSTOREGOODS_ERP_TIPS = 'onlineStoreGoods_erp_tips'
export const ONLINESSTOREGOODS_ERP_TIPS_FFROM_ERP = 'onlineStoreGoods_erp_tips_ffrom_erp'

// 优质分销商来源
export const QUALITY_CHANNEL_AUTO = 'QUALITY_CHANNEL_AUTO' // 自动计算
export const QUALITY_CHANNEL_MANUAL = 'QUALITY_CHANNEL_MANUAL' // 中台手工打标

export const WHETHER_OPEN_BRAND_STATION_OPTIONS = [
    {
        label: '开通',
        value: 'OPEN'
    },
    {
        label: '开通并上传LOGO和展位图',
        value: 'OPEN_CONFIG'
    },
    {
        label: '未开通',
        value: 'CLOSED'
    }
]
export const OPERATORTYPE_OPTIONS = [
    {
        value: 0,
        label: '待选'
    },
    {
        value: 1,
        label: '选入'
    },
    {
        value: 2,
        label: '暂缓'
    },
    {
        value: 3,
        label: '汰换'
    }
]
